import Honeybadger from 'honeybadger-js'

export { Honeybadger }



// WEBPACK FOOTER //
// ./src/config/production.js